import React, { useMemo } from 'react';
import { VendorComplianceRequirementItem } from '../../types';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { getRequirementStatusClasses, groupRequirementsByCategory } from '../../utils/complianceRequirements';
import { formatDate } from '../../utils/vendorCompliance';

interface ComplianceRequirementsChecklistProps {
  requirements: VendorComplianceRequirementItem[];
}

const ComplianceRequirementsChecklist: React.FC<ComplianceRequirementsChecklistProps> = ({ requirements }) => {
  const grouped = useMemo(() => groupRequirementsByCategory(requirements), [requirements]);

  if (!requirements.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Requirements Checklist</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        {Object.entries(grouped).map(([category, items]) => (
          <div key={category}>
            <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{category}</h4>
            <div className="space-y-2">
              {items.map((item) => (
                <div
                  key={item.key}
                  className="flex items-start justify-between gap-3 rounded-md border border-gray-200 dark:border-gray-700 px-3 py-2"
                >
                  <div className="min-w-0">
                    <div className="text-sm font-medium text-gray-900 dark:text-gray-100">{item.label}</div>
                    {item.detail && (
                      <div className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{item.detail}</div>
                    )}
                    {item.relevantDate && (
                      <div className="text-xs text-gray-500 dark:text-gray-500 mt-0.5">
                        {formatDate(item.relevantDate)}
                      </div>
                    )}
                  </div>
                  <span
                    className={`inline-flex flex-shrink-0 px-2 py-1 rounded-full text-xs font-medium ${getRequirementStatusClasses(item.status)}`}
                  >
                    {item.statusLabel}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ComplianceRequirementsChecklist;
